/*
 * @Author: zyq
 * @Date: 2022-10-19 09:57:01
 * @LastEditors: zyq
 * @LastEditTime: 2022-10-26 00:50:45
 * @description:
 */
import Vue from 'vue'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import '@/assets/font/font.css'
import App from './App'
import { Button, Dialog, Icon, InfiniteScroll, Input, Option, Select } from 'element-ui'
import 'amfe-flexible'
import '@/assets/ali/iconfont.css'
import '@/assets/styles/global.css'

Vue.use(VXETable)
Vue.use(Select)
Vue.use(Option)
Vue.use(Icon)
Vue.use(Input)
Vue.use(InfiniteScroll)
Vue.use(Dialog)
Vue.use(Button)

Vue.config.productionTip = false
Vue.prototype.$ZIP_IMG = '?imageMogr2/thumbnail/!30p'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
